module.exports = __webpack_public_path__ + "media/images/mobile/city_img/b3-7b986c1e71988e931dcc9b168d939015.jpg";